import type { ReactNode } from 'react';
import { memo } from 'react';
import loadable from '@loadable/component';
import { DEFINITION_URLS } from './constants';
import { ChartDefinitionsContext } from './ChartDefinitionsContext';

const Definitions = loadable(() => import('./Definitions'), {
  ssr: false,
  resolveComponent: (component) => component.Definitions,
});

const DefinitionsMemo = memo(Definitions);

export const LoadableChartDefinitionsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <ChartDefinitionsContext.Provider value={DEFINITION_URLS}>
      <DefinitionsMemo />
      {children}
    </ChartDefinitionsContext.Provider>
  );
};
